import styled, { keyframes, css } from "styled-components";

const fadeOutLeft = keyframes`
  from { opacity: 1; transform: translateX(0); }
  to   { opacity: 0; transform: translateX(-20px); }
`;

// Styles
export const MainDiv = styled.div`
  padding: 16px;
  width: 370px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  border: 2px solid #f15a24;
  background-color: #fff;
  gap: 8px;
  position: absolute;
  top: 130px;
  right: -400px;
  gap: 8px;
`;
export const Header = styled.div`
  margin-bottom: 14px;
  width: 100%;
  display: flex;
  gap: 4px;
`;
export const WarningImg = styled.img`
  width: 30px;
  height: 30px;
`;
export const TitlesBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const Title = styled.p`
  color: #000;
  font-size: 16px;
  font-weight: 600;
`;
export const Subtitle = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: 400;
`;

export const NotificationBox = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  background: #f3f3f3;
  ${({ leaving }) =>
    leaving &&
    css`
      animation: ${fadeOutLeft} 260ms ease forwards;
    `}
`;
export const NotificationHeader = styled.div`
  margin-bottom: 9px;
  width: 100%;
  display: flex;
  gap: 9px;
`;
export const NotificationImg = styled.img`
  width: 20px;
  height: 20px;
`;
export const NotificationTitle = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: 600;
`;
export const ActionsContainer = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent && justifyContent};
`;
export const IgnoreButton = styled.button`
  padding: 8px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: ${({ border }) => border && border};
  background: ${({ background }) => background && background};
  color: ${({ color }) => color && color};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
export const ActionButton = styled.button`
  padding: 8px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: none;
  outline: none;
  background-color: #f15a24;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
`;
